import React, { useState } from 'react';
import { IconButton, Tooltip, ClickAwayListener } from '@mui/material';
import { size } from 'lodash-es';

function ClickableTooltipWrapper({
  message,
  children,
  ...rest
}) {
  const [open, setOpen] = useState(false);

  const messageLength = size(message);
  let timeout = 2000;
  if (messageLength > 50)
    timeout = Math.min(5000, (messageLength - 50) * 50 + 2000);

  const handleClick = (e) => {
    if (children.props.onClick) children.props.onClick(e);

    // Close and re-open ensures only this tooltip stays open
    setOpen(false);
    setTimeout(() => setOpen(true), 0);

    // Auto close
    setTimeout(() => setOpen(false), timeout);
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div style={{ display: 'inline-block' }}>
        <Tooltip
          {...rest}
          open={open}
          title={message}
          disableFocusListener
          disableHoverListener
          disableTouchListener
        >
          <IconButton
            size="small"
            onClick={handleClick}
            disableRipple
            disableFocusRipple
            sx={{ padding: 0 }}
          >
            {children}
          </IconButton>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
}


export default ClickableTooltipWrapper;
